import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link
              to="/"
              className="flex items-center gap-2 text-lg font-bold text-foreground-950 mb-4 whitespace-nowrap"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              <span className="text-primary-500 text-xl w-6 h-6 flex items-center justify-center">
                <i className="ri-book-open-line"></i>
              </span>
              虚空韩漫网
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              韩漫画免费网站，提供漫画大全和韩漫完整在线观看服务。平台稳定是您可靠的长久阅读伙伴。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              快速链接
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  恋爱漫画
                </Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  奇幻漫画
                </Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  动作漫画
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              热门分类
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/thriller" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  悬疑漫画
                </Link>
              </li>
              <li>
                <Link to="/category/drama" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  剧情漫画
                </Link>
              </li>
              <li>
                <Link to="/category/comedy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  搞笑漫画
                </Link>
              </li>
              <li>
                <Link to="/category/bl" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  BL漫画
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-900 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap">
                  联系我们
                </Link>
              </li>
            </ul>
            <div className="mt-4 flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-100 hover:text-primary-500 transition-colors" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 虚空韩漫网. 版权所有.
          </p>
          <p className="text-xs text-foreground-500">
            本站所有漫画资源均来自互联网，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}